// 隐藏命令面板中的文字至图表命令项
(function () {
  // 创建一个函数来处理命令项
  function hideTextToDiagramCommand() {
    // 查找所有命令项
    const commandItems = document.querySelectorAll(
      ".command-palette-dialog .command-category .command-item",
    );

    // 遍历所有命令项
    commandItems.forEach((item) => {
      // 获取命令项的文本内容
      const text = item.textContent || "";

      // 获取name元素的文本内容（更精确）
      const nameElement = item.querySelector(".name");
      const nameText = nameElement ? nameElement.textContent || "" : "";

      // 如果文本内容包含"文字至图表"，则隐藏该命令项
      if (
        text.includes("文字至图表") ||
        text.includes("text to diagram") ||
        nameText.includes("文字至图表") ||
        nameText.includes("text to diagram")
      ) {
        item.style.display = "none";
      }
    });
  }

  // 在DOM加载完成后执行
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initObserver);
  } else {
    initObserver();
  }

  // 初始化观察器
  function initObserver() {
    // 创建一个观察器来监视DOM变化
    const observer = new MutationObserver((mutations) => {
      // 检查是否有命令面板对话框
      const commandPaletteDialog = document.querySelector(
        ".command-palette-dialog",
      );
      if (commandPaletteDialog) {
        // 如果命令面板对话框存在，执行隐藏操作
        hideTextToDiagramCommand();
      }
    });

    // 开始观察文档变化
    observer.observe(document.body, { childList: true, subtree: true });

    // 立即执行一次隐藏操作
    hideTextToDiagramCommand();
  }
})();
